import { render, staticRenderFns } from "./TransferirBaixaCreditoDeOperadora.vue?vue&type=template&id=777a83db&"
import script from "./TransferirBaixaCreditoDeOperadora.vue?vue&type=script&lang=js&"
export * from "./TransferirBaixaCreditoDeOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports